import React from 'react';
import styles from './style.module.css';

export default ({
    icon = '?',
    content = ''
} = {}) => (
    <div className={styles.tooltip}>
        <div className={styles.tooltipIcon}>
            <span>{icon}</span>
        </div>
        <div className={styles.tooltipContent}>
            <p>{content}</p>
        </div>
    </div>
);
